const fetch = require("node-fetch");
import { getPlayerId } from "../utils/playerId";

export const fetchAllJokes = () => {
  return dispatch => {
    const player_id = getPlayerId();
    const query = player_id ? "?player=" + encodeURIComponent(player_id) : "";
    return fetch("/api/all_jokes" + query,{method:"GET"})
    .then(handleErrors) 
    .then(res => res.json())
    .then(json => {
      dispatch(fetchAllJokesSuccess(json))
        return json;
      })
      .catch(error => dispatch(fetchAllJokesFailure(error)));
  };
}
 
function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}

export const NEXT_JOKE =
  "NEXT_JOKE"
export const HINT_CLICKED =
  "HINT_CLICKED";
export const UNSOLVE =
  "UNSOLVE";
export const TOGGLE_MUTE =
  "TOGGLE_MUTE";
export const OUT_OF_JOKES =
  "OUT_OF_JOKES";
export const LOAD_JOKE_BY_ID =
  "LOAD_JOKE_BY_ID";
export const RESTART_JOKE =
  "RESTART_JOKE";
export const FETCH_ALL_JOKES_SUCCESS =
  "FETCH_ALL_JOKES_SUCCESS";
export const FETCH_ALL_JOKES_FAILURE =
  "FETCH_ALL_JOKES_FAILURE";

export const unsolve = () => ({
  type: UNSOLVE
})

export const toggle_mute = () => ({
  type: TOGGLE_MUTE
});

export const fetchAllJokesSuccess = (all_jokes) => ({
  type: FETCH_ALL_JOKES_SUCCESS,
  payload: { all_jokes }
});

export const fetchAllJokesFailure = error => ({
  type: FETCH_ALL_JOKES_FAILURE,
  payload: { error }
})

export const nextJoke = () => ({
  type: NEXT_JOKE,
})

export const hintClicked = () => ({
  type: HINT_CLICKED,
})

export const loadJokeById = (joke_id) => ({
  type: LOAD_JOKE_BY_ID,
  payload: { joke_id }
})

export const restartJoke = (joke) => ({
  type: RESTART_JOKE,
  payload: { joke }
})

// a joke already solved (so not in the fetched unseen queue) isn't
// reachable via loadJokeById - this fetches it directly (full word list
// included) so "Restart" on /solved/<id> can re-scramble and replay it
export const fetchJokeDetailAndRestart = (joke_id) => {
  return dispatch => {
    return fetch("/api/joke_detail/" + joke_id, {method:"GET"})
    .then(handleErrors)
    .then(res => res.json())
    .then(json => {
      dispatch(restartJoke(json.joke))
      return json.joke;
    });
  };
}